import React from "react";
import { Link } from "react-router-dom";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { AvatarWithName } from "../../../../components/Avatar";
import { CustomSortIcon } from "../../../../components/DatatableHelpers";
import FormattedDateAndTime from "../../../../components/FormattedDateAndTime";
import { CoursePeerReview } from "./UsageFilteredByCourseViewModel";

export function PeerReviewUsageTable(props: {
	className?: string;
	peerReviews: CoursePeerReview[];
}) {
	const reviewDateBodyTemplate = (rowData: CoursePeerReview) => {
		return (
			<Link className="link" to={`/reviews/${rowData.reviewId}`}>
				<FormattedDateAndTime date={rowData.reviewDate} />
			</Link>
		);
	};

	const reviewerBodyTemplate = (rowData: CoursePeerReview) => {
		return (
			<AvatarWithName
				userId={rowData.reviewerId}
				name={rowData.reviewerName}
				initials={rowData.reviewerInitials}
				hasImage={rowData.reviewerHasImage}
			/>
		);
	};

	const authorBodyTemplate = (rowData: CoursePeerReview) => {
		return (
			<AvatarWithName
				userId={rowData.writerId}
				name={rowData.writerName}
				initials={rowData.writerInitials}
				hasImage={rowData.writerHasImage}
			/>
		);
	};

	return (
		<DataTable
			value={props.peerReviews}
			dataKey="reviewId"
			loading={props.peerReviews == undefined}
			emptyMessage="No results found"
			stripedRows
			sortIcon={CustomSortIcon}
			className={`block tbl tbl-data tbl-datatable min-w-[40rem] cursor-default ${props.className}`}>
			<Column
				header="Date"
				body={reviewDateBodyTemplate}
				sortable
				sortField="reviewDate"></Column>
			<Column header="Prompt" field="promptName" sortable></Column>
			<Column
				header="Reviewer"
				body={reviewerBodyTemplate}
				sortable
				sortField="reviewerName"></Column>
			<Column
				header="Author"
				body={authorBodyTemplate}
				sortable
				sortField="writerName"></Column>
		</DataTable>
	);
}
